//
//
//
//
//
//
//
//
//

import Shadowable from "../../mixins/Shadowable";
import Dimensionable from "../../mixins/Dimensionable";
import Linkable from "../../mixins/Linkable";
import CardMixin from "./CardMixin";
import Hoverable from "../../mixins/Hoverable";
import Colorable from "../../mixins/Colorable";

const ProgressBar = () => import('../Loader/ProgressBar')

export default {
    name: "Card",
    components: {ProgressBar},
    mixins: [CardMixin, Shadowable, Dimensionable, Linkable, Hoverable, Colorable],

    props: {

        xSmall: {
            type: Boolean,
            default: false
        },

        small: {
            type: Boolean,
            default: false
        },

        // States that the card has a dark background and the text colors shall be lightened up
        dark: {
            type: Boolean,
            default: false
        },

        // A boolean to state whether a medium shadow shall be shown or a specific shadow size string
        shadow: {
            type: [String, Boolean],
            default: true
        },

        // The color of the loading indicator
        loadingColor: {
            type: String,
            default: 'primary'
        }
    },

    computed: {
        tag() {
            if (this.absoluteTo) {
                return 'a';
            }
            if (this.relativeTo) {
                return 'nuxt-link';
            }

            return 'div';
        }
    }
}
